module.exports = __webpack_public_path__ + "static/showcase-c617959cce99d444fb91fd6192fbe33a.jpg";